module.exports = __webpack_public_path__ + "img/instagamIcon.1aa164a.png";